export const LOGO_URL = "/assets/logo.png";

export const PLANS = [
  {
    key: "student_annual",
    name: "Student",
    price: "£27",
    per: "/year",
    badge: null,
    cta: "GET STUDENT — £27/YR",
    startCta: "GET STUDENT — £27/YR",
    renews: "£27/year. Cancel any time inside your account.",
    blurb: "Designed for students and learners.",
    features: [
      "Research, study & learning commands",
      "Productivity & admin commands",
      "Personal development commands",
      "AI Emergency Toolkit",
      "One-click copy on mobile & desktop",
      "Bonus Quick-Command Cheat Sheet",
    ],
  },
  {
    key: "pro_annual",
    name: "Pro",
    price: "£47",
    per: "/year",
    badge: "MOST POPULAR",
    cta: "GET PRO — £47/YR",
    startCta: "GET PRO — £47/YR",
    renews: "£47/year. Cancel any time inside your account.",
    blurb: "For small businesses, managers, admins, freelancers, consultants & entrepreneurs.",
    features: [
      "Full searchable command database",
      "All business, marketing & sales commands",
      "Everything in Student",
      "New commands as they're added",
      "Favourites & recently used",
      "Bonus Quick-Command Cheat Sheet",
    ],
  },
  {
    key: "lifetime",
    name: "Lifetime",
    price: "£99",
    per: " one-off",
    badge: "BEST LONG-TERM VALUE",
    cta: "GET LIFETIME ACCESS — £99",
    startCta: "GET LIFETIME ACCESS — £99",
    renews: "Pay once. Use it for life.",
    blurb: "Full Pro access forever. No annual renewal.",
    features: [
      "Full Pro access",
      "Lifetime access — no renewal",
      "Future standard command additions",
      "Future standard categories",
      "Favourites & recently used",
      "Bonus Quick-Command Cheat Sheet",
    ],
  },
];

export const INTRO_PLAN = {
  key: "pro_intro",
  name: "Intro Offer",
  price: "£4.99",
  per: " first month",
  badge: null,
  cta: "JOIN NOW — £4.99",
  startCta: "JOIN NOW — £4.99",
  renews: "£4.99 today for 1 month of full Pro access, then £47/year unless you cancel before your month ends.",
  blurb: "Try everything Pro offers for a full month.",
  features: [
    "Full searchable command database",
    "All business, marketing & sales commands",
    "New commands as they're added",
    "Favourites & recently used",
    "Bonus Quick-Command Cheat Sheet",
  ],
};

export const FAQS = [
  { q: "Do I need to know how to code?", a: "No." },
  { q: "Do I need to understand prompt engineering?", a: "No." },
  { q: "Does this work with ChatGPT?", a: "Yes. The commands are designed as simple instructions for ChatGPT, Claude and Gemini." },
  { q: "Are these official slash commands?", a: "No. They are shorthand prompting instructions designed to make communicating with AI quicker and easier. AI Shorthand commands are simple prompting shortcuts designed to help users tell AI what they want it to do. They are not official built-in slash commands supplied by ChatGPT, Claude or Gemini." },
  { q: "Can I use the dictionary on my phone?", a: "Yes." },
  { q: "Will new commands be added?", a: "Yes. The searchable database will continue to grow." },
  { q: "What is Student membership?", a: "Student access is designed mainly around research, study, learning and general productivity." },
  { q: "What is Pro membership?", a: "Pro provides access to the full standard business and professional command library." },
  { q: "What does Lifetime mean?", a: "Lifetime gives the member full Pro access without annual renewal." },
  { q: "Can we cope with thousands of users?", a: "XpressPrompts is built for scalable deployment. Its lightweight search-and-copy architecture supports large user populations efficiently, with infrastructure capacity that can be increased as concurrent usage grows. This allows organisations to begin with a pilot and expand across departments, locations or the wider workforce without changing how employees use the platform." },
];
